exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-enter-active,\n.v-leave-active {\n    transition: opacity 0.05s ease;\n}\n.v-enter-from,\n.v-leave-to {\n    opacity: 0;\n}\n\n", ""]);

// exports
